import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { MaintenanceRoutineHomologousModel } from 'src/app/models/maintenance/maintenance-routine-homologous.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceRoutineHomologousService {

  constructor(private _httpClient: HttpClient) { }

  createMultipleHomologousAsync(listHomologous: MaintenanceRoutineHomologousModel[], maintenancRoutineId: number, articleId: number): Observable<boolean> {
    return this._httpClient.post<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceRoutineHomologous.CreateMultipleHomologousAsync}/${maintenancRoutineId}/${articleId}`,
      listHomologous);
  }

  deleteElement(maintenancRoutineHomologousId: number): Observable<MaintenanceRoutineHomologousModel> {
    return this._httpClient.delete<MaintenanceRoutineHomologousModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceRoutineHomologous.DeleteAsync}/${maintenancRoutineHomologousId}`);
  }

  deleteSomeHomologous(elementIds: number[]): Observable<boolean> {
    return this._httpClient.put<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceRoutineHomologous.DeleteSomeDetailsAsync}`,
      elementIds);
  }

  getAllSuppliesHomologousAsync(maintenanceRoutineId: number, mainArticleId: number, page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant).set('maintenanceRoutineId', maintenanceRoutineId).set('mainArticleId', mainArticleId);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceRoutineHomologous.GetAllSuppliesHomologousAsync}`,
      filters, { params: params }
    );
  }

  getHomologousByMainArticle(maintenanceRoutineId: number, mainArticleId: number, page: number, limit: number, columnSort: string | null, ascendant: boolean): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant).set('maintenanceRoutineId', maintenanceRoutineId).set('mainArticleId', mainArticleId);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceRoutineHomologous.GetHomologousByMainArticleAsync}`, null,
      { params: params }
    );
  }

  getMaintenanceRoutineHomologousById(id: number): Observable<MaintenanceRoutineHomologousModel> {
    return this._httpClient.get<MaintenanceRoutineHomologousModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceRoutineHomologous.GetByIdAsync}/${id}`);
  }


  getColumnsAsync(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceRoutineHomologous.GetColumnsAsync}`);
  }

  getColumnsForSuppliesAsync(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceRoutineHomologous.GetColumnsForSuppliesAsync}`);
  }
}
